module.exports = __webpack_public_path__ + "img/monitoring-car-selected.703397f5.svg";